import { render, staticRenderFns } from "./SettingsUpdateDialog.vue?vue&type=template&id=582d03f5&"
import script from "./SettingsUpdateDialog.vue?vue&type=script&lang=ts&"
export * from "./SettingsUpdateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports